import { css, makeStyles } from '@conexasaude/conexa-hero'

const useStyles = makeStyles({
  doctorSection: ({ spacing, border, colors }) => css`
    width: 400px;
    height: 120px;
    border: 1px solid ${colors.neutral[200]};
    border-radius: ${border.radius.lg};
    padding: ${spacing.xs};
    margin: ${spacing.xs} 0 ${spacing.xs} 0;
    flex-grow: 1;
  `,
  avatar: ({ spacing }) => css`
    margin-right: ${spacing.xs};
  `,
})

export default useStyles
